import { render, staticRenderFns } from "./AlatReuseMenuPage.vue?vue&type=template&id=79ed66cb&scoped=true&"
import script from "./AlatReuseMenuPage.vue?vue&type=script&lang=ts&"
export * from "./AlatReuseMenuPage.vue?vue&type=script&lang=ts&"
import style0 from "./AlatReuseMenuPage.vue?vue&type=style&index=0&id=79ed66cb&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79ed66cb",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAvatar } from 'vuetify/lib/components/VAvatar';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VChip } from 'vuetify/lib/components/VChip';
import { VChipGroup } from 'vuetify/lib/components/VChipGroup';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VAvatar,VCard,VCardText,VChip,VChipGroup,VCol,VContainer,VIcon,VRow})
